// extracted by mini-css-extract-plugin
export default {"wrapper":"HorseTabs_wrapper__nowJV","element":"HorseTabs_element__7ZTFL","view":"HorseTabs_view__JmFkz","text":"HorseTabs_text__YPeKx","isActive":"HorseTabs_isActive__LtDg+"};